import React from 'react'

import * as icons from '../icons'
import { IconProps } from '../icons/types'
import { classes } from '../utils'

type Props = {
  /** Panel variant to be shown */
  variant?: 'danger' | 'info' | 'warning' | 'success' | 'promo'
  /** Optional icon to be shown. */
  icon?: keyof typeof icons
  /** Panel message. */
  message: string | (() => React.ReactNode)
  /** External class */
  className?: string
}

/** Message panel used to show inline messages to the user. */
const MessagePanel = ({ variant, message, icon, className }: Props) => {
  const MessageIcon = icon
    ? (icons as Record<string, React.FunctionComponent<IconProps>>)[icon]
    : null

  return (
    <div
      className={classes(
        'grid w-full grid-flow-col items-center gap-x-3 rounded-none border-l-2 p-3 text-foreground-normal',
        {
          'grid-cols-min-fr': !!MessageIcon,
          'border-l-fill-info bg-fill-info-secondary': variant === 'info',
          'border-l-fill-critical bg-fill-critical-secondary':
            variant === 'danger',
          'border-l-fill-warning bg-fill-warning-secondary':
            variant === 'warning',
          'border-l-fill-success bg-fill-success-secondary':
            variant === 'success',
          'border-l-fill-promo bg-fill-promo-secondary': variant === 'promo',
        },
        className,
      )}
    >
      {!!MessageIcon && <MessageIcon className="h-5 w-5" />}
      <div>
        {message && typeof message === 'function' ? message() : message}
      </div>
    </div>
  )
}

MessagePanel.defaultProps = {
  variant: 'info',
}

export default MessagePanel
